import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    token: localStorage.getItem('token'),
    clientSlug: localStorage.getItem('client'),
    user: {},
    client: localStorage.getItem('client') ? localStorage.getItem('client') : {},
    activeNavbar: 'main',
    activeTaskObject: {},
    activeTaskPosition: 0,
    tabIndex: '',
    taskToolbarState: false,
    helpCenterState: false,
    activeGuideScope: {},
    activeFilters: {},
    tableColumns: localStorage.getItem('tableColumns') ? localStorage.getItem('tableColumns') : {},
    updateTasks: false,
    reloadTasks: 1,
    reloadCount: 1,
    updatedObject: {},
    updateContent: 1,
    historyPage: localStorage.getItem('historyPage') ? localStorage.getItem('historyPage') : null,
    updatePage: 1,
    wordpressLink: '',
    perPage: localStorage.getItem('perPage') ? localStorage.getItem('perPage') : '',
    shortPerPage: localStorage.getItem('shortPerPage') ? localStorage.getItem('shortPerPage') : '',
  },
  mutations: {
    storeUser(state, payload) {
      state.user = payload;
    },

    storeActiveTask(state, payload) {
      state.activeTaskObject = payload;
    },

    storeActiveGuideScope(state, payload) {
      state.activeGuideScope = payload;
    },

    storeActiveTaskPosition(state, payload) {
      state.activeTaskPosition = payload;
    },

    setNavType(state, payload) {
      state.activeNavbar = payload;
    },

    storeClient(state, payload) {
      state.client = payload;
    },

    storeTabIndex(state, payload) {
      state.tabIndex = payload;
    },

    storeTaskToolbarState(state, payload) {
      state.taskToolbarState = payload;
    },

    storeHelpCenterState(state, payload) {
      state.helpCenterState = payload;
    },

    storeActiveFilters(state, payload) {
      // let columns;
      // if (localStorage.getItem('activeFilters')) {
      //   columns = JSON.parse(localStorage.getItem('activeFilters'));
      // } else {
      //   columns = {};
      // }
      // columns[payload.type] = payload.activeFilters;
      // localStorage.setItem('activeFilters', JSON.stringify(columns));
      state.activeFilters[payload.type] = payload.filters;
    },

    storeTableColumns(state, payload) {
      let columns;
      if (localStorage.getItem('tableColumns')) {
        columns = JSON.parse(localStorage.getItem('tableColumns'));
      } else {
        columns = {};
      }

      columns[payload.type] = payload.tableColumns;
      localStorage.setItem('tableColumns', JSON.stringify(columns));
    },

    storePerPage(state, payload) {
      localStorage.setItem('perPage', payload);
      state.perPage = payload;
    },

    storeShortPerPage(state, payload) {
      localStorage.setItem('shortPerPage', payload);
      state.shortPerPage = payload;
    },

    storeProcessPageNumber(state, payload) {
      localStorage.setItem('processPageNumber', payload);
      state.processPageNumber = payload;
    },

    storeUpdateTasks(state, payload) {
      state.updateTasks = payload;
    },

    storeWordpressLink(state, payload) {
      state.wordpressLink = payload;
    },

    storeUpdateContent(state, payload) {
      state.updateContent += 1;
      state.updatedObject = payload;
    },

    storeReloadTasks(state, payload) {
      state.reloadTasks += 1;
    },

    storeReloadCount(state, payload) {
      state.reloadCount += 1;
    },

    storeUpdatePage(state, payload) {
      state.updatePage += 1;
    },

    storeHistoryPage(state, payload) {
      localStorage.setItem('historyPage', payload);
      state.historyPage = payload;
    },
  },
  getters: {
    isLoggedIn: state => {
      return state.isLoggedIn;
    },

    getClient: state => {
      return state.client;
    },

    getActiveTask: state => {
      return state.activeTaskObject;
    },

    getTabIndex: state => {
      return state.tabIndex;
    },

    getTaskToolbarState: state => {
      return state.taskToolbarState;
    },

    getClientSlug: state => {
      return state.clientSlug;
    },
  },
  actions: {
    handleToken(context) {
      context.commit('increment');
    },
  },
});
